<script setup lang="tsx">
import { ref } from 'vue'
import Multiselect from 'vue-multiselect'
import http from '@/services/http'
import { TagModule } from '@/models/enums-generated'
import type { Response } from '@/models/api-generated'
import type { DefaultFilter } from '@/models/filters-generated'

const props = defineProps<{
	url: string
	exludeIds?: number[]
	instanceId?: number
	label: string
	class?: any
	type: string
	validInput: boolean
	assetId?: number
}>()

const model = defineModel<any>({ required: true })
const options = ref<any[]>([])
const isLoading = ref(false)
const isOpen = ref(false)

function handleOpen() {
	isOpen.value = true
	search('')
}

async function search(q: string) {
	isLoading.value = true
	const params: DefaultFilter = {
		q,
		type: props.type,
		excludeIds: props.exludeIds ?? [],
		instanceId: props.instanceId ?? 0,
		assetId: props.assetId ?? 0,
	}

	const { data } = await http.post<Response<any[]>>(props.url, params)
	const formatted = (data.data ?? []).map((obj) => {
		return {
			...obj,
			name: props.type === TagModule ? `${obj.description} (${obj.name})` : obj.name,
		}
	})
	options.value = formatted.sort((a, b) => a.name.localeCompare(b.name))

	isLoading.value = false
}
</script>

<template>
	<Multiselect
		:class="{ 'is-invalid': !props.validInput }"
		:multiple="false"
		:show-labels="false"
		:options="options"
		:internal-search="false"
		:preserve-search="true"
		:show-no-results="false"
		:loading="isLoading"
		v-model="model"
		label="name"
		track-by="id"
		@search-change="search"
		@open="handleOpen"
		:placeholder="props.label + '...'"
		:taggable="false"
		:use-teleport="true"
	>
		<template #option="{ option }">
			<div class="d-flex justify-content-between align-items-center w-100">
				<span>{{ option.name }}</span>
			</div>
		</template>
	</Multiselect>
</template>
